import React from 'react'
import { Link } from 'react-router-dom'
import NavBottom from './NavBottom'
import NavTop from './NavTop'

export default function Navbar() {
  return (
    <>
    <NavTop/>
    <NavBottom/>
    </>
  )
}
